import { render } from "./PattyAuditRecordReadOnly.vue?vue&type=template&id=0c8a4584&scoped=true"
import script from "./PattyAuditRecordReadOnly.vue?vue&type=script&lang=js"
export * from "./PattyAuditRecordReadOnly.vue?vue&type=script&lang=js"

import "./PattyAuditRecordReadOnly.vue?vue&type=style&index=0&id=0c8a4584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8a4584"]])

export default __exports__